export default {
  language: 'o‘zbek tili',
  month: ["Yanvar'", "Fevral'", "Mart", "Aprel'", "May", "Iyun'", "Iyul'", "Avgust", "Sentyabr'", "Oktyabr'", "Noyabr'", "Dekabr'"],
  days: ["Yak", "Du", "Se", "Chor", "Pay", "Ju", "Shan"],
  interface: {
    selfAssign: 'Agar o`zingizni ko`rsatmoqchi bo`lsangiz, <br> bo‘sh qoldiring',
    chooseEmployee: 'Xodimni tanlang',
    chooseSource: 'Asos hujjatni tanlang',
    chooseSender: 'Yuboruvchini tanlang',
    chooseDocument: 'Hujjatni tanlang',
    addExternalOrganization: 'Tashqi tashkilot qo`shish',
    termCases: {
      progress: 'Ijro muddat tugayapti',
      done: 'Ijro muddati kechiktirildi',
      unknown: 'Ijro muddati',
    },
    search: 'Qidiruv...',
    preview: 'Hujjatni ko`rish',
    advancedSearch: 'Kengaytirilgan qidiruv',
    all: 'Barchasi',
    authored: 'Men muallif',
    maintained: 'Men mas\'ul',
    executed: 'Men ijrochi',
    expired: 'Muddati o‘tgan',
    expiring: 'Muddati tugamagan',
    without_term: 'Muddatsiz',
    apply: 'Qo‘llash',
    accept: 'Qabul qilish',
    checked: 'Tasdiqlangan',
    cancel: 'Bekor qilish',
    send: 'Yuborish',
    clearFilters: 'Filtrni tozalash',
    nothingFound: 'Ma\'lumot topilmadi,yana harakat qilib ko‘ring',
    resetFiltersAndSearch: 'Filtrlar va qidiruvni tozalash',
    edit: 'Tahrirlash',
    publish: 'E\'lon qilish',
    startExecution: 'Ijroga kirishish',
    endExecution: 'Ijroni tugatish',
    information: 'Ma\'lumot',
    inputNote: 'Izoh kiriting',
    rejectNote: 'Qaytarish sababini ko‘rsating',
    description: 'Qisqacha mazmuni',
    fileDeletingAcceptation: 'Faylni o‘chirishga ishonchingiz komilmi?',
    fileSuccessfulDeleted: 'Fayl muvaffaqiyatli o‘chirildi',
    areYouSureRemove: 'Ushbu obyektni o‘chirishga ishonchingiz komilmi?',
    confirm: 'Amalni tasdiqlang',
    remove: 'O‘chirish',
    exportExcel: 'Excelga eksport qilish',
    date: 'Sana',
    save: 'Saqlash',
    allEmployees: 'Barcha xodimlar uchun',
    requiredFields: '* belgili shart bo‘lgan barcha maydonlarni to‘ldiring',
    allRequired: 'Barcha maydonlar to‘ldirilishi shart',
    changeTerm: 'Muddatni o‘zgartirish',
    applicantDocumentId: 'Murojaatchi identifikatori',
    employeeSelectTip: `Ushbu so‘rovnoma bo‘yicha vakolatli xodimlarni belgilang. <br>
                        Bir yoki bir necha xodimni tanlash uchun quyidagi klavishlarni
                        bosib turib ularni belgilang
                        <span class="kbd">Ctrl</span> yoki <span class="kbd">Shift</span>.`,
    uploadFile: 'Faylni yuklash',
    noFiles: 'Qayd etish uchun fayllar mavjud emas',
    noInternet: 'Internet aloqasi yo‘q',
    checkInternet: 'Internet aloqasini tekshiring.',
    noFileSelected: 'Fayl tanlanmagan',
    historyBack: 'Orqaga',
    employeeChoose: 'Xodimni tanlang',
    globalSearchPlaceholder: 'Hujjatlar,topshiriqlar va xodimlar bo‘yicha qidiruv...',
    selectSource: 'Manbani tanlang',
    time: 'Vaqt',
    notifications: 'Bildirish',
    notificationsEmpty: 'Yangi e‘lonlar yo‘q.',
    reject: 'Rad etish',
    return: 'Qaytarish',
    restore: 'Ijroga qaytarish',
    noTimelineActions: 'Qayd etishga amallar mavjud emas.',
    welcome: 'Xush kelibsiz,',
    myProfile: 'Mening profilim',
    profileSettings: 'Profil sozlamalari',
    exit: 'Chiqish',
    removeSelected: 'Tanlanganlarni o‘chirish',
    dataDeleting: 'Ma\'lumotlarni o‘chirish',
    dataDeletingMessage: 'Ushbu ma\'lumotlarni o‘chirishga ishonchingiz komilmi?',
    start_date: 'Sana boshi',
    end_date: 'Sana oxiri',
    export: 'Yuklab olish',
    card: 'Hujjat varaqasi',
    downloadDocument: 'Hujjatni yuklab olish',
    registerCard: 'Titul varaqasi',
    downloadInstruction: 'Yo`riqnoma',
    changePassword: 'Parolni o`zgartirish',
    passwordsNotMatch: 'Kiritilgan yangi parollar bir xil bo’lishi kerak',
    old_password: 'Hozirgi parolingiz',
    new_password: 'Yangi parol',
    repeat_password: 'Yangi parolni takrorlang',
    password_changed: 'Parolingiz o’zgartirildi',
    createNewObject: 'Yangi',
    hide: 'bekitish',
    dragDropFiles: 'Faylni yuklash uchun shu yerga tashlang',
    confirmFileUpload: 'E`tibor bering. Hujjatga faylni yuklab olmoqchimisiz?',
    dragDropNote: 'Faylni yuklash uchun shu yerga tashlang',
    generalDocument: 'Hujjat fayli',
    allDocumentsTemplate: 'Blankli shablon',
    orderTemplate: 'Blanksiz shablon',
    y: 'Ha',
    n: 'Yo‘q',
  },
  routes: {
    documents: 'Topshiriq',
    globalSearch: 'Qidiruv',
    docflowIncoming: 'Kiruvchi hujjatlar',
    docflowOutgoing: 'Chiquvchi hujjatlar',
    createResolution: 'Rezolyutsiya yozish',
    editResolution: 'Rezolyutsiyani o‘zgartirish',
    createDocument: 'Yangi topshiriq',
    createPlanItem: 'Chora-tadbirlar rejasining yangi bandi',
    createPlanGroup: 'Chora-tadbirlar rejasining yangi guruhi',
    editPlanGroup: 'Chora-tadbirlar rejasi guruhini o‘zgartirish',
    editPlanItem: 'Chora-tadbirlar rejasi bandini o‘zgartirish',
    editDocument: 'Topshiriqni o‘zgartirish',
    documentDetail: 'Topshiriqni ko‘rish',
    docflowPlanItemDetail: 'Ijrochilar',
    createTask: 'Yangi vazifa',
    editTask: 'Vazifani o‘zgartirish',
    taskDetail: 'Vazifa',
    projects: 'Loyihalar',
    createProject: 'Yangi loyiha',
    editProject: 'Loyihani o‘zgartirish',
    projectDetail: 'Loyiha',
    createPhase: 'Yangi bosqich (faza)',
    editPhase: 'Bosqich (faza)ni  o‘zgartirish',
    createContractor: 'Yangi pudratchi',
    editContractor: 'Pudratchini o‘zgartirish',
    createSpending: 'Mablag‘ni o‘zlashtirishning yangi turi',
    editSpending: 'Mablag‘ni o‘zlashtirish turini o‘zgartirish',
    createFinancingSource: 'Moliyalashning yangi manbasi',
    editFinancingSource: 'Moliyalash manbasini o‘zgartirish',
    createIssue: 'Loyiha bo‘yicha yangi savol',
    editIssue: 'Loyiha bo‘yicha savolni o‘zgartirish',
    departments: 'Bo‘linmalar',
    departmentDetail: 'Bo‘linmalarni ko‘rish',
    issues: 'Talabnomalar',
    createIssueTracker: 'Yangi talabnoma',
    editIssueTracker: 'Talabnomani o‘zgartirish',
    issueDetail: 'Talabnomani ko‘rish',
    reportsList: 'Hisobotlar',
    userReport: 'Foydalanuvchi hisoboti',
    employeeExecutionReport: 'Topshiriqlar ijrosi hisoboti',
    employeesOverdueDocumentsByRegisterBooks: 'Ijrosi muddatida bajarilmagan hujjatlar (kartotekalar kesimida)',
    surveys: 'So‘rovnomalar',
    surveyDetail: 'So‘rovnomani ko‘rish',
    surveyResults: 'So‘rovnoma natijasi',
    createSurvey: 'Yangi so‘rovnoma',
    editSurvey: 'So‘rovnomani o‘zgartirish',
    resources: 'Resurslar',
    createReservation: 'Band qilish',
    employeeDetail: 'Profilni ko‘rish',
    editEmployeeData: 'Profilni o‘zgartirish',
    announcements: 'Anonslar',
    createAnnouncement: 'Yangi anons',
    docflow: 'Hujjatlar',
    createDocflow: 'Yangi hujjat',
    editDocflow: 'Hujjatni tahrirlash',
    docflowDetail: 'Hujjatni ko‘rish',
    docflowAgreementsList: 'Kelishish uchun',
    docflowRegistrationsList: 'Ro‘yxatdan o‘tkazish uchun',
    dashboard: 'Asosiy',
    docflowRegister: 'Hujjatni ro‘yxatdan o‘tkazish',
    docflowAppeals: 'Fuqarolar murojaati',
    manageDepartments: 'Departamentlar ro‘yxati',
    createDepartments: 'Departament yaratish',
    editDepartments: 'Departamentni o‘zgartirish',
    externalOrganizations: 'Tashqi tashkilotlar',
    createExternalOrganizations: 'Tashqi tashkilot qo‘shish ',
    editExternalOrganizations: 'Tashqi tashkilotni o‘zgartirish ',
    positions: 'Xodimlar ierarxiyasi',
    createPosition: 'Yozuv qo‘shish',
    editPosition: 'Yozuvni o‘zgartirish',
    postNames: 'Lavozimlar',
    createPostName: 'Lavozim kiritish',
    editPostName: 'Lavozimini o‘zgartirish',
    registerBooks: 'Kartotekalar',
    createRegisterBook: 'Kartoteka qo‘shish',
    editRegisterBook: 'Kartotekani o‘zgartirish',
    documentTypes: 'Hujjatlar turi',
    createDocumentType: 'Hujjatlar turini qo‘shish',
    editDocumentType: 'Hujjatlar turini o‘zgartirish ',
    deliveryTypes: 'Yetkazish turlari',
    createDeliveryType: 'Yetkazish turini qo‘shish',
    editDeliveryType: 'Yetkazish turini o‘zgartirish',
    resourceCategories: 'Resurslar toifalari',
    createResourceCategory: 'Resurslar toifasini yaratish',
    editResourceCategory: 'Resurslar toifasini o‘zgartirish',
    manageResources: 'Resurslar',
    createResource: 'Resurs qo‘shish',
    editResource: 'Resursni o‘zgartirish',
    employees: 'Xodimlar',
    createEmployee: 'Xodimni qo‘shish',
    editEmployee: 'Xodimni o‘zgartirish',
    issueCategories: 'Talabnoma toifalari',
    createIssueCategory: 'Talabnoma toifasini qo‘shish',
    editIssueCategory: 'Talabnoma toifasini o‘zgartirish',
    shortBySenders: 'Kiruvchi va chiquvchi hujjatlar haqida',
    expiringDocsByRegisterBooks: 'Muddati tugagan yoki tugayotgan hujjatlar ro`yxati',
    changePassword: 'Parolni o`zgartirish',
    appealsByCategoriesAndRegions: 'Murojaatlarning masalalar va viloyatlar bo`yicha taqqoslama tahlili',
    employeesDocsByState: 'Xodimlar kesimida hujjatlar holati bo`yicha hisobot',
    analyticsDashboard: 'Interaktiv Tahlil',
    tasks: 'Vazifalar',
  },
  navigation: {
    service: 'Xizmatlar',
    docflow: 'Hujjatlar',
    documents: 'Topshiriqlar',
    projects: 'Loyihalar',
    departments: 'Bo‘linmalar',
    issues: 'Talabnomalar',
    surveys: 'So‘rovnomalar',
    globalSearch: 'Qidiruv',
    resources: 'Resurslar',
    reportsList: 'Hisobotlar',
    announcements: 'Anonslar',
    admin: 'Ma\'muriyat',
    employees: 'Xodimlar',
    manageDepartments: 'Bo‘linmalar',
    externalOrganizations: 'Tashqi tashkilotlar',
    positions: 'Xodimlar ierarxiyasi',
    postNames: 'Lavozimlar',
    cloud: 'Xotira',
    docflowIncoming: 'Kiruvchi hujjatlar',
    docflowOutgoing: 'Chiquvchi hujjatlar ',
    docflowAppeals: 'Murojaatlar',
    docflowAgreementsList: 'Kelishuv uchun',
    docflowRegistrationsList: 'Ro‘yxatdan o‘tkazish uchun',
    documentTypes: 'Hujjatlar toifalari',
    registerBooks: 'Kartotekalar',
    deliveryTypes: 'Yetkazish toifalari',
    resourceCategories: 'Resurslar toifalari',
    manageResources: 'Resurslar',
    dashboard: 'Ishchi muhiti',
    extendedDashboard: 'Ishchi muhiti',
    issueCategories: 'Talabnomalar toifalari',
    analyticsDashboard: 'Interaktiv Tahlil',
  },
  workflow: {
    doctypes: {
      info: 'Ma‘lumot uchun',
      task: 'Vazifa'
    },
    sourceTypes: {
      internal: 'Ichki',
      external: 'Tashqi'
    },
    priorities: {
      low: 'Past',
      medium: 'O‘rta',
      high: 'Yuqori'
    },
    states: {
      draft: 'Qoralama',
      new: 'Yangi',
      in_process: 'Ijroda',
      done: 'Ijro etildi',
      rejected: 'Qaytarildi',
      closed: 'Yopildi',
      active: 'Faol',
      cancelled: 'Bekor qilindi',
      pending_resolution: 'Rezolyutsiya yozilishi kutilmoqda',
      pending_plan_agreement: 'PM kelishuvi',
      resolution_filled: 'Rezolyutsiya yozildi',
      resolution_approved: 'Rezolyutsiya tasdiqlandi',
      resolution_rejected: 'Rezolyutsiya qaytarildi',
      pending_checkout: 'Tanishishga jo`natildi',
      pending_agreement: 'Kelishuv jarayonida',
      pending_closing: 'Yopish jarayonida',
      agreed: 'Kelishildi',
      approved: 'Tasdiqlandi',
      registration_number_attached: 'Ro`yxatga olingan',
      published: 'E\'lon qilindi',
      executive_checking: 'Ijro apparatida'
    },
    changeStates: {
      pending_approve: 'O‘zgartirishga so‘rov',
      rejected: 'O‘zgartirishga so‘rov rad etildi',
      approved: 'O‘zgartirishga so‘rov qabul qilindi',
      done: 'O‘zgartirishga so‘rov bajarildi',
    },
    maintainerTypes: {
      maintainer: 'Mas\'ul',
      executor: 'Qo‘shimcha ijrochi'
    }
  },
  projectControl: {
    sourceTypes: {
      internal: 'Ichki',
      external: 'Tashqi'
    },
    contractorTypes: {
      planning: 'Texnik-iqtisodiy asosni (TIA) ishlab chiqish',
      realization: 'Realizasiya'
    },
    states: {
      'new': 'Boshlanmagan',
      contractor_definition: 'Pudratchini aniqlash',
      in_process: 'Bajarilmoqda',
      completed: 'Bajarildi',
      cancelled: 'Bekor qilindi'
    },
    issueStatuses: {
      'new': 'Savol ochiq',
      in_process: 'Hal qilinmoqda',
      completed: 'Hal qilindi',
      cancelled: 'Bekor qilindi',
      paused: 'To‘xtatildi'
    }
  },
  notification: {
    verbs: {
      document_pending_resolution: 'Hujjat rezolyutsiya yozilish uchun yuborildi',
      document_resolution_filled: 'Hujjat bo‘yicha rezolyutsiya yozildi',
      document_resolution_approved: 'Hujjat rezolyutsiyasi tasdiqlandi',
      document_pending_checkout: 'Hujjat bilan tanishish kutilmoqda',
      document_checked_out: 'Hujjat bilan tanishish',
      document_checkout_rejected: 'Hujjat,u bilan tanishish bosqichida qaytarildi',
      document_pending_agreement: 'Hujjat kelishuvni kutmoqda',
      document_agreed: 'Hujjat kelishilgan va tasdiqlanishni kutmoqda',
      document_approved: 'Hujjat tasdiqlandi',
      document_published: 'Hujjat e\'lon qilindi',
      document_in_process: 'Hujjat ijrosi boshlandi',
      document_pending_closing: 'Hujjat yopishni kutmoqda',
      document_closed: 'Hujjat bo‘yicha ish tamomlandi',
      received_document_for_registration: 'Ro‘yxatdan o‘tkazish uchun hujjat qabul qilindi',
      assigned_to_assignment_as_maintainer: 'Topshiriq bo‘yicha masu\'l tayinlandi',
      assigned_to_task_as_executor: 'Vazifa bo‘yicha mas\'ul tayinlandi',
      task_in_process: 'Vazifa ijrosi boshlandi',
      task_done: 'Vazifa bajarildi',
      task_closed: 'Vazifa yopildi',
      task_rejected: 'Vazifa natijasi qaytarildi',
      task_cancelled: 'Vazifa bekor qilindi',
      assignment_closed: 'Topshiriq yopildi',
      assignment_cancelled: 'Topshiriq bekor qilindi',
      expiring_documents: 'Bajarilish muddati o‘tgan topshiriqlar',
      expiring_tasks: 'Bajarilish muddati o‘tgan vazifalar',
      survey_created: 'Yangi so‘rov e\'lon qilindi',
      announcement_created: 'Yangi e\'lon e\'lon qilindi',
      issue_created: 'Yangi talabnoma e\'lon qilindi',
      issue_in_process: 'Talabnoma ijrosi boshlandi',
      issue_cancelled: 'Talabnoma bekor qilindi',
      issue_done: 'Talabnoma bo‘yicha ishlar tugatildi',
      document_cancelled: 'Hujjat bekor qilingan',
      document_pending_cancellation: 'Bekor qilinishi kutilmoqda',
      document_rejected: 'Hujjat qaytarildi',
    }
  },
  documents: {
    taskDetail: {
      total: 'Xammasi',
      done: 'Yopilgan',
      expired: 'Kechiktirilgan',
    },
    sourceTypes: {
      standalone: 'Qo`lda kiritilgan',
      document: 'Hujjat',
      document_resolution: 'Rezolyutsiya',
      document_plan: 'Chora-tadbir',
      project: 'Loyiha',
      program: 'Dastur',
    },
    list: 'Topshiriqlar ro‘yxati',
    newDocument: 'Yangi topshiriq',
    filters: {
      role: 'Rol',
      expiration: 'Muddati o‘tgan',
      state: 'Status',
      priority: 'Prioritet',
      sourceType: 'Manba turi',
      type: 'Topshiriq turi',
      branch: 'Yo‘nalish',
      project: 'Loyiha',
      source: 'Manba',
      docType: 'Hujjat turi',
      registerBook: 'Kartoteka',
    },
    fields: {
      title: 'Sarlavha',
      project: 'Loyiha',
      state: 'Status',
      term: 'Muddat',
      tasks: 'Vazifalar',
      author: 'Muallif',
      role: 'Rol',
      source: 'Manba',
      maintainer: 'Mas\'ul',
      legalDocNum: 'Asos hujjatning qayd raqami',
      legalDocDate: 'Asos hujjatning sanasi',
      sourceType: 'Asos',
      based_on_docs: 'Hujjat asosidagi topshiriqlarni ko‘rsatish',
    },
    infoDoc: 'Topshiriq ma‘lumot uchun',
    notViewedByMaintainer: 'Ko‘rilmadi',
    viewedByMaintainer: 'Ko‘rildi',
    maintainer: 'Nazorat qiluvchi',
    executive_maintainer: 'Mas\'ul ijrochi',
    executor: 'Ijrochi',
    executors: 'Ijrochilar',
    removeDocument: 'Topshiriqni o‘chirish',
    rejectDocument: 'Topshiriqni bekor qilish',
    rejectSubmition: 'Topshiriqni bekor qilishga ishonchingiz komilmi? Bu amalni bekor qilish mumkin emas.',
    tasks: 'Vazifalar',
    attachments: 'Biriktirilgan fayllar',
    document: 'Hujjat',
    progress: 'Topshiriq bajarilishi jarayoni'
  },
  tasks: {
    type: 'Turi',
    removeTask: 'Vazifani o‘chirish',
    rejectTask: 'Vazifani bekor qilish',
    rejectSubmition: 'Vazifanini bekor qilishga ishonchingiz komilmi? Bu amalni bekor qilish mumkin emas.',
    guarantor: 'Hujjat bo‘yicha mas‘ul',
    currentState: 'Joriy status',
    termDate: 'Ijro muddati',
    progress: 'Vazifa bajarilishi jarayoni',
    inputNameToAddUser: 'Foydalanuvchilarga qo‘shish uchun ism kiriting',
    name: 'Ismi',
    state: 'Status',
    viewed: 'Ko‘rilgan',
    notViewed: 'Ko‘rilmagan',
    actions: 'Amallar',
    position: `{position}  departamentda <b>{department}</b>`,
    executorsAddTip: 'Ijrochini qo‘shish uchun ism yoki departament nomini qidiruv maydoniga kiriting va zarur xodimni tanlang.',
    taskType: 'Vazifa turi',
    term: 'Muddat',
    addMeAsExecutor: 'Meni ijrochi qilib belgilash',
    termError: 'Vazifa ijrosi uchun muddat belgilang',
    showMy: 'Faqat menga tegishlilarni  ko‘rsatish',
    showExpired: 'Muddati o‘tganlarni ko‘rsatish',
    create: 'Yangi vazifa tuzish',
    filters: {
      period: 'Muddat',
      expiration_period: 'Muddati kechiktirilgan'
    },
    periods: {
      week: '10 kun',
      month: '30 kun',
      year: 'Yil boshidan',
    },
    ePeriods: {
      expired: 'Kechiktitildi',
      expiring: 'Bugun-erta',
      expires_in_5_days: '5 kungacha',
      expires_in_14_days: '6-14 kun',
      expires_after_14_days: '14 kundan ko‘p',
    }
  },
  announce: {
    list: 'Elonlar ro‘yxati',
    create: 'Yangi elon',
    title: 'Nomi'
  },
  employees: {
    username: 'Foydalanuvchi ismi sharfi',
    chatNumber: 'suxbat №',
    actions: 'Amal',
    departmentList: 'Bo‘linmalar ro‘yxati',
    position: 'Lavozim',
    department: 'Departament',
    birthday: 'Tug‘ilgan kun',
    mobilePhone: 'Mobil telefon raqami',
    workPhone: 'Xizmat telefon raqami',
    hiredDate: 'Ishga qabul qilish sanasi (data nayma)',
    dismissalDate: 'Ishga qabul qilish sanasi (data nayma)',
    category: 'Kategoriya',
    workplace: 'Ofis/Bino',
    about: 'O‘zim haqimda',
    workLoad: 'Shtatdagilar soni',
    level: 'Qavat',
    cabinet: 'Xona',
    profilePhoto: 'Foydalanuvchi profil fotosi',
    interfaceSetups: 'Tizim sozlamalari',
    language: 'Interfeys tili',
    telegramNotifications: '«Telegram messendjer»iga ogohlantirishlar',
    documentPreview: 'Hujjatni ko`rish',
    telegramSessions: 'Telegram sessiyalari',
    noActiveSessions: 'Sizda faol Telegram sessiyasi mavjud emas'
  },
  issueTracker: {
    list: 'Talabnomalar ro`yxati',
    notAssigned: 'Ijrochi tayinlanmadi',
    newIssue: 'Yangi talabnoma',
    incoming: 'Kiruvchi',
    outgoing: 'Chiquvchi',
    expired: 'Muddati kechiktirilgan',
    expiring: 'Muddati buzulmagan',
    issue: 'Talabnoma',
    reject: 'Talabnomani bekor qilish',
    author: 'Talabnoma muallifi',
    executor: 'Ijrochi',
    priority: 'Prioritet',
    currentState: 'Joriy status',
    category: 'Kategoriya',
    term: 'Bajarish muddati',
    progress: 'Bajarilish jarayoni',
    rejectAcceptation: 'Talabnomani bekor qilishga ishonchingiz komilmi? Bu amalni bekor qilish mumkin emas.',
    file: 'Biriktirilgan fayl',
    downloadFile: 'Biriktirilgan faylni yuklab olish',
  },
  projects: {
    list: 'Loyihalar reestri',
    create: 'Yangi loyiha tuzish',
    title: 'Sarlavha',
    sourceType: 'Manba turi',
    projectType: 'Loyiha manbasi',
    branch: 'Yo‘nalish/Dastur',
    customer: 'Buyurtmachi',
    beneficiary: 'Benefisiar',
    department: 'Bo‘lim',
    budget: 'Rejali byudjet',
    planStartDate: 'Rejali sana boshlanishi',
    planEndDate: 'Rejali sana tugallanishi',
    factStartDate: 'Boshlanish haqiqiy sanasi',
    factEndDate: 'Tugallanish haqiqiy sanasi',
    maintainer: 'Mas\'ul',
    budgetError: 'Rejali byudjetni qayd qiling',
    spend: 'Haqiqatda sarflangan',
    legals: 'Asos',
    files: 'Fayllar',
    state: 'Status',
    phases: 'Bosqich',
    financingSources: 'Moliyalashtirish manbalari',
    contractors: 'Pudratchilar',
    spending: 'Mablag‘ni o‘zlashtirish',
    issues: 'Loyiha vazifalari',
  },
  reports: {
    nothingFound: 'Xech narsa topilmadi',
    chooseDepartmentForReport: 'Boshqarmani tanlang',
    chooseDepartment: 'Boshqarmani tanlang',
    date: 'Sana',
    list: 'Xisobotlar ro‘yxati',
    startDate: 'Davr boshi',
    endDate: 'Davr oxiri',
    department: 'Departament',
    fullname: 'FIO',
    documentsTasks: 'Topshiriqlar/Vazifalar',
    notStarted: 'Boshlanmadi',
    inProgress: 'Ijro etilmoqda',
    done: 'Bajarildi',
    closed: 'Tugallandi',
    total: 'Jami',
    appealTotal: 'Jami murojaatlar',
    expired: 'shu jumladan muddati o‘tganlar',
    documents: 'Topshiriqlar',
    tasks: 'Vazifalar',
    noDataAtSelectedDate: 'Tanlangan sana bo‘yicha  ma\'lumotlar  mavjud emas, boshqa sana tanlab ko‘ring.',
    userStats: {
      progress: 'jarayonda',
      done: 'Bajarildi',
      expired: 'Muddati o‘tgan',
    },
    author: 'Muallif',
    begin: 'Boshlanishi',
    end: 'Tugallanishi',
    state: 'Status',
    registerBook1: 'Kartoteka 1',
    registerBook2: 'Kartoteka 2',
    registerBook3: 'Kartoteka 3',
    registerBook4: 'Kartoteka 4',
    appeals: 'Murojaatlar',
    other: 'Qolgan hujjatlar',
    incomingDocs: 'Kiruvchi hujjatlar',
    innerDocs: 'Ichki va chiquvchi hujjatlar',
    from: 'Kimdan',
    count: 'Soni',
    docNumber: 'Hujjat raqami',
    description: 'Mazmuni',
    registeredDate: 'Ro`yxatga olingan sanasi',
    maintainer: 'Mas\'ul shaxs',
    termDate: 'Belgilangan muddat',
    termDelay: 'Kechikish (kun)',
    category: 'Hujjat turi',
    emtByStates: 'Hujjatlar kesimida ijro',
    emtByExpiration: 'Ijro muddatlari',
    executiveAnalytics: 'Ijro tahlili',
    activityAnalytics: 'Ijrochilarning vazifalarning ijro faolligini',
    byStates: 'Statuslar kesimida',
    byAD: 'Kartoteka kesimida',
    daily: 'Kunlar kesimida',
    monthly: 'Oylar kesimida',
  },
  resources: {
    available: 'Mavjud resurslar',
    createReservation: 'Resursni zahiraga saqlash (Rezervasiya)',
    begin: 'Boshlanishi',
    end: 'Tugallanishi',
    resource: 'Resurs',
    reserve: 'Resursni zahiraga saqlash (Rezervasiya)'
  },
  surveys: {
    possibleAnswer: 'Javob varianti',
    list: 'So‘rovnomalar ro‘yxati',
    answerToSave: 'Saqlash uchun barcha savollarga javob bering',
    expire: 'Tugashi',
    results: 'Natijalar',
    publish: 'E\'lon qilish',
    stop: 'To‘xtatib turish',
    isAnswered: 'So‘rovnoma o‘tkazildi',
    resultsDescription: 'So‘rovnomada ishtirok etishdi {answeredEmployeesCount} ulardan {employeesCount} so‘rovnomada qatnashgan xodimlar.',
    votes: '{count} ovozlar',
    title: 'Nomi',
    endDate: 'Tugallanish sanasi',
    questions: 'Savollar',
    questionText: 'Savol matni',
    single_option: 'Bir',
    multi_option: 'Ko‘p',
    question_answer: 'Javob matni',
    addVariant: 'Javob variantini qo‘shish',
    removeQuestion: 'Savolni o‘chirish',
    addQuestion: 'Savolni qo‘shish',
  },
  comments: {
    title: 'Izohlar',
    edited: 'Tahrir qilindi',
    noComments: 'Ko‘rishga izohlar yo‘q.',
    inputComment: 'Izohlar kiriting',
    send: 'Yuborish',
    remove: 'Izohni o‘chirish',
    removeSubmission: 'Ushbu izohlarni o‘chirishga ishonchingiz komilmi? Bu amalni bekor qilish mumkin emas.'
  },
  contractors: {
    counterpart: 'Kontragent',
    type: 'Ishtirok etish turi',
    contractDate: 'Shartnoma sanasi',
    contractNumber: 'Shartnoma qayd-raqami',
    contractAmount: 'Shartnoma qiymati',
    contractFile: 'Shartnoma fayli',
    create: 'Pudratchini tashkil etish',
  },
  financingSources: {
    source: 'Moliyaviy manba ',
    percent: 'Moliyalashtirish foizi',
    percentError: 'Moliyalashtirish foizi manfiy bo‘lishi mumkin emas',
    create: 'Moliyalashtirishning yangi manbasini tashkil etish',
  },
  issues: {
    type: 'Turi',
    priority: 'Muximligi',
    category: 'Kategoriyasi',
    author: 'Muallif',
    executor: 'Mas‘ul ijrochi',
    create: 'Yangi vazifani tashkil etish',
    title: 'Nomi',
    state: 'Status',
    employee: 'Xodim',
    department: 'Bo‘lim',
    term: 'Muddat',
    startDate: 'Boshlanishning reja sanasi',
    startedDate: 'Boshlanish haqiqiy sanasi',
    completedDate: 'Tugallanish sanasi',
  },
  spending: {
    create: 'Mablag‘ni o‘zlashtirishning yangi turini  yaratish',
    contractor: 'Pudratchi',
    amount: 'O‘zlashtirish summasi',
    date: 'Akt sanasi',
    number: '№ akt',
    file: 'Sharnoma fayli'
  },
  docflow: {
    is_absent: 'Mavjud emas',
    checkouts: 'Tanishtiruv',
    decisionType: 'Natija turi',
    parentDocument: 'Asos hujjat',
    close: 'Nazoratdan yechish',
    applicant: 'Murojaatchi ma\'lumotlari',
    is_informational: 'Ma\'lumot uchun',
    is_classified: 'Xizmat doirasida foydalanish uchun',
    is_pending_cancellation: 'Bekor qilinishi kutilmoqda',
    is_forwarded: 'Qayta yo‘naltirilgan hujjat',
    is_group_appeal: 'Jamoaviy murojaat',
    checkouts_list: 'Tanishuv ro`yxati',
    attachRegistrationNumber: 'Ro`yxatga olish',
    signed: 'ERI bilan tasdiqlangan',
    checkout: {
      name: 'Ismi',
      state: 'Status',
      states: {
        new: 'Tanishtirish kutilmoqda',
        rejected: 'Rad etildi',
        cancelled: 'Tanishish bekor qilindi',
        checked_out: 'Tanishildi',
        excluded: 'Ro‘yxatdan chiqarildi',
        not_checked: 'Tanishilmadi'
      }
    },
    resend_appeal: 'Murojaatni yuborish',
    agree: 'Tanishdim',
    regNumberDoesNotExists: 'Hujjat',
    setPlanTitle: 'Sarlavhani o‘zgartirish',
    planTitlePlaceholder: 'Sarlavhani kiriting',
    realisation_mechanisms: 'Ijro mexanizmi',
    approver: 'Tasdiqlovchi',
    planControlHelp: 'Yopilganlar / Bajarilganlar/ Ijro jarayonida/ Yangi',
    plan: {
      name: 'Chora tadbir bandi',
      realisation_mechanisms: 'Ijro mexanizmi',
      maintainer: 'Mas’ul ijrochi',
      executors: 'Ijrochilar',
      term: 'Ijro muddati',
    },
    maintainer: 'Mas\'ul',
    list: 'Hujjatlar ro‘yxati',
    sendForAgreement: 'Kelishuvga yuborish',
    sendForApprove: 'Tasdiqlashga yuborish',
    pend: 'Kelishish',
    approve: 'Tasdiqlash',
    register: 'Ro‘yxatdan o‘tkazish',
    publish: 'E\'lon qilish',
    agreePlan: 'Chora-tadbirlar rejasini kelishish',
    sureRemove: 'O‘chirishga ishonchingiz komilmi?',
    removePlanGroup: 'Guruh bilan birga barcha tarmoq elementlar ham o‘chadi.',
    removePlanItem: 'Bu amalni bekor qilish mumkin emas.',
    executors: 'Ijrochilar',
    assignmentsTip: 'Ushbu hujjat asosida topshiriq mavjud emas.',
    approveResolution: 'Rezolyutsiyani tasdiqlash',
    sendToCreateResolution: 'Rezolyutsiya yozish uchun yuborish',
    editResolution: 'Rezolyutsiyani boshqarish',
    sendChangeRequest: 'O‘zgartirish so‘rovi',
    author: 'Muallif',
    newDocument: 'Yangi hujjat',
    informational: 'Ma‘lumot uchun',
    createPlanItem: 'Band qo‘shish',
    createPlanGroup: 'Guruh qo‘shish',
    resolution: 'Rezolyutsiya',
    noPlanItemsExist: 'Band mavjud emas. «Band qo‘shish» tugmasini bosib yangi band kiriting.',
    planOrderNumber: 'Tartib raqami',
    termDate: 'Muddat',
    planGroup: 'Guruh',
    maintainerType: 'Mas\'ul toifasi',
    organization: 'Tashkilot',
    department: 'Departament',
    maintainer_organization: 'Mas\'ul tashkilot',
    maintainer_department: 'Mas\'ul departament',
    noPlanMaintainer: 'Tayinlanmagan',
    noPlanExecutors: 'Ijrochilarni tayinlash',
    documentPlan: 'Chora-tadbirlar rejasi',
    createResolution: 'Rezolyutsiya yozish',
    noResolution: 'Rezolyutsiya yozilmagan',
    resolutionTemplates: 'Rezolyutsiya namunalari',
    attachments: 'Biriktirilgan fayllar',
    planControl: 'PM ijrosi nazorati',
    assignmentsControl: 'Bog‘liq topshiriqlar',
    relatedDocumentsControl: 'Bog‘liq hujjatlar',
    progress: 'Jarayon',
    addNewCorespondent: 'Tashqi korrespondensiyani qo‘shish"{name}"',
    correspondents: 'Qabul qilib oluvchilar',
    correspondentsAddTip: 'Ro‘yxatga qo‘shish uchun yuqorida belgilingan  maydonga korrespondensiya nomini kiritishni boshlang.',
    inputNameToAdd: 'Qidirish va qo‘shish uchun nomini kiriting',
    excludeExternalCorrespondents: 'Xalq ta‘lim sohasidagi tashkilotlar',
    correspondent: {
      name: 'Qabul qilib oluvchilar'
    },
    docTypes: {
      incoming: 'Kiruvchi',
      outgoing: 'Chiquvchi',
      internal: 'Ichki',
      appeals: 'Murojaatlar',
      appeal: 'Murojaatlar',
    },
    fullDocTypes: {
      incoming: 'Kiruvchi hujjat',
      outgoing: 'Chiquvchi hujjat',
      appeal: 'Murojaat'
    },
    fields: {
      resolution_maintainer: 'Мas’ul ijrochi',
      supervisor: 'Nazorat qiluvchi',
      resolution_term_date: 'Rezolyutsiya ijrosi muddati',
      registration_number: 'Ro‘yxatdan o‘tkazish qayd-raqami ',
      description: 'Mazmuni',
      category: 'Kategoriya',
      registered_date: 'Ro‘yxatdan o‘tkazish sanasi',
      type: 'Hujjat turi',
      term_date: 'Ijro muddati',
      file: 'Faylni yuklash',
      is_informational: 'Ma‘lumot uchun',
      resolution_author: 'Rezolyutsiya muallifi',
      delivery_type: 'Yetkazish turi',
      original_document_number: 'Asli hujjat qayd-raqami',
      original_document_date: 'Asli hujjat sanasi',
      resolution: 'Rezolyutsiya',
      resolution_approver: 'Rezolyutsiyani tasdiqlovchi shaxs',
      register_book: 'Kartoteka',
      sender: 'Yuboruvchi tashkilot',
      appealType: 'Murojaat toifsi',
      applicantType: 'Murojaat etuvchi turi',
      applicant_name: 'Murojaatchi familiy, ismi va sharfi',
      applicant_passport_number: 'Pasport seriyasi va  raqami',
      applicant_work_phone: 'Xizmat telefoni',
      applicant_mobile_phone: 'Telefon raqami',
      applicant_region: 'Hudud',
      applicant_area: 'Tuman',
      applicant_address: 'Yashash joyi',
      applicant_company_name: 'Korxona nomi',
      is_classified: 'Xizmat doirasida foydalanish uchun',
      is_group_appeal: 'Jamoaviy murojaat',
      is_repeated_appeal: 'Takroriy murojaat',
      appeal_sender: 'Jo’natgan tashkilot nomi',
      appeal_category: 'Murojaat masalasi',
      spotter: 'Tahrirlovchi',
      lawyer: 'Huquqshunos'
    },
    appealTypes: {
      statement: 'Ariza',
      complaint: 'Shikoyat',
      proposal: 'Taklif',
      thank: 'Tashakkurnoma',
      anonymous: 'Anonim'
    },
    applicantTypes: {
      individual_person: 'Jismoniy shaxs',
      legal_person: 'Yuridik shaxs'
    },
    categories: {
      incoming: 'Kiruvchi',
      outgoing: 'Chiquvchi',
    },
    incomingTip: 'Original hujjat {name} ot {date}',
    workflow: {
      title: 'Topshiriq',
      name: 'Topshiriq nomi',
      term_date: 'Muddati',
    },
    filters: {
      state: 'Status',
      is_expired: 'Muddati o‘tganlar',
      is_informational: 'Ma‘lumot uchun',
      is_classified: 'Xizmat doirasida foydalanish uchun',
      created_date_from: 'Yaratilish sanasi  dan',
      created_date_to: 'Yaratilish sanasi  gacha',
      term_date_from: 'Muddat sanasi   dan',
      term_date_to: 'Muddat sanasi   gacha',
      is_repeated_appeal: 'Takroriy murojaat',
      is_group_appeal: 'Jamoaviy murojaat',
      applicant_type: 'Murojaat egasi toifasi',
    },
    changeRequest: {
      title: 'O‘zgartirish so‘rovi',
      downloadFile: 'Bildirishni yuklash',
      file: 'Bildirish'
    }
  },
  dashboard: {
    title: 'Ishchi muhit',
    common_items: 'Kun tartibida',
    in_process_items: "Ijroda",
    expired_items: 'Muddati tugadi',
    controlled_items: 'Nazoratda',
    extended: {
      common_documents: 'Kun tartibida',
      expired_documents: 'Muddati tugadi',
      controlled_documents: 'Nazoratda',
    },
    emptyList: 'Ushbu toifadagi hujjatlar yo\'q',
    announcements: 'Elonlar',
    itemTypes: {
      incoming_document: 'Kiruvchi hujjatlar',
      outgoing_document: 'Chiquvchi hujjatlar',
      appeal_document: 'Murojaat',
      assignment: 'Topshiriq',
      task: 'Vazifa'
    },
    sort: {
      dateAsc: 'Muddati (oldin yangilar)',
      dateDesc: 'Muddati (oldin eskilar)',
      priorityAsc: 'Muhimligi (oldin muhimlari)',
      priorityDesc: 'Muhimligi (oldin muhimmaslari)',
    }
  },
  admin: {
    name: 'Nomi',
    parent: 'Roditel',
    abbr: 'Abreviatura',
    registerBook: 'Kartoteka',
    weight: 'Приоритет',
    post_name: 'Lavozimi',
    inn: 'INN',
    department: 'Departament',
    category: 'Toifa',
    maintainer: 'Mas\'ul',
    docTypeCategory: {
      incoming: 'Kiruvchilar uchuy',
      outgoing: 'Chiquvchilar uchun',
      appeal: 'Murojaatlar uchun',
    },
    employee_name: 'Ismi',
    last_name: 'Familiyasi',
    patronymic: 'Sharifi',
    initials: 'Shaxsi bosh haflari',
    gender: 'Jinsi',
    male: 'Erkak',
    female: 'Ayol',
    birthday: 'Tug‘ilgan kuni',
    mobile_phone: 'Mobil telefon raqami',
    work_phone: 'Xizmat telefon raqami',
    hired_date: 'Ishga qabul qilish sanasi',
    dismissal_date: 'Ishdan bo‘shash sanasi',
    is_dismissed: 'Bo‘shaganmi?',
    workplace_office: 'Ofis/Bino',
    workplace_level: 'Qavat',
    workplace_cabinet_number: 'Xona',
    position: 'Lavozimi',
    userData: 'Foydalanuvchi ma\'lumotlari',
    login: 'Login',
    password: 'Parol',
    password2: 'Tasdiqlash',
    bio: 'Tarjimai xol',
    passwordsWrong: 'Kiritilgan parollar bir-biriga mos kelmadi',
    analytic_dimension: 'Tahliliy kesim',
  },
  notFound: {
    subtitle: 'Obyekt mavjud emas',
    description: 'Ushbu obyekt o‘chirib tashlangan yoki sizda obyektni ko‘rish huquqi mavjud emas',
    goBack: 'Orqaga qaytish'
  },
  direct: {
    doneDay: 'Bajarilgan kun',
    question: 'Savol',
    mail_date_index: 'Ilova xatning sanasi,indeksi',
    registration_date_index: 'Kelgan sanasi,indeksi',
    control_type: 'Nazoratni turi',
    progress: 'Bajarishnining borishi',
    receiver_and_date: 'Oluvchi va sana',
    progress_date: 'Bajarishga berish sanasi',
    sent_to: 'Qayerga yuborilgan',
    control_sign: 'Nazorat belgilari',
    progress_index: 'Indeks bajarishi',
    executor_sign: 'Bajaruvchining imzosi',
    removed_from_control: 'Nazoratdan olindi',
    control: 'Nazorat',
    no: 'Yoq',
    qr: 'Hujjat ERI shu qr kod orqali tekshirib ko’rish mumkin',
    term: 'muddat',
  },
  globalSearch: {
    documents: 'Hujjatlar',
    assignments: 'Topshiriqlar',
    employees: 'Xodimlar',
  },
  regions: {
    krk: 'Qoraqalpog`iston Respublikasi',
    and: 'Andijon',
    bkh: 'Buxoro',
    jzh: 'Jizzax',
    ksh: 'Qashqadaryo',
    nvo: 'Navoyi',
    nmg: 'Namangan',
    smr: 'Samarqand',
    srd: 'Sirdaryo',
    srh: 'Surxondaryo',
    tshr: 'Toshkent v.',
    tshc: 'Toshkent sh.',
    frg: 'Farg`ona',
    khr: 'Xorazm',
    other: 'Boshqa hududdan',
  },
  employeeDetail: {
    floor: 'qavat',
    cabinet: 'xona',
  },
  errors: {
    chooseFileType: 'Yuklanadigan fayl turini tanlang',
    chooseFile: 'Faylni tanlang',
    noPossibleAnswer: 'Savol uchin kamida bitta javob bo‘lishi kerak',
    noQuestion: 'So‘rovnomada kamida bitta savol bo‘lishi kerak',
    undefined: 'Amalni bajarib bo‘lmadi',
    organizationNotFound: 'Kiritilgan ma`lumotlarni qayta tekshiring, yoki yangi tashkilot qo`shish uchun tizim administratoriga murojaat qiling',
  },
  sign: {
    incorrectPassword: 'ERI uchin noto‘g‘ri parol',
    eimzoNotFound: 'E-IMZO o‘rnatilmagan yoki ishlatilmagan.',
    keyNotFound: 'ERI raqam kaliti topilmadi.'
  }
}
